import React, { useEffect } from 'react';
import { MenuItem, Select, InputLabel, FormControl, Button, CircularProgress } from '@mui/material';
import { SensorData, DoorSensorData } from '../../../types/SensorData';
import { _fetchTagList } from '../../../api/api';

export interface RapportListProps {
  selectedMac: string;
  onSensorSelect: (macAddr: string) => void;
  onToggleSettings: () => void;
}

export interface RapportListProps {
  selectedMac: string;
  onSensorSelect: (macAddr: string) => void;
  onToggleSettings: () => void;
}

export interface RapportListProps {
  selectedMac: string;
  onSensorSelect: (macAddr: string) => void;
  onToggleSettings: () => void;
}

const RapportList: React.FC<RapportListProps> = ({ 
  selectedMac, 
  onSensorSelect,
  onToggleSettings 
}) => {
  const [sensors, setSensors] = React.useState<(SensorData | DoorSensorData)[]>([]);
  const [loading, setLoading] = React.useState(false);

  // Fetch sensor list on component mount
  useEffect(() => {
    const loadSensors = async () => {
      setLoading(true);
      try {
        console.log('Chargement des capteurs pour RapportList...');
        const response = await _fetchTagList(1, 1000); // Charger tous les capteurs
        console.log('Réponse API capteurs:', response);

        if (response.data && response.data.success && response.data.result) {
          const sensorsData = Array.isArray(response.data.result) ? response.data.result : [];
          console.log('Sensors data received:', sensorsData.length);

          // Convert backend tag data to sensor format
          const transformedSensors: (SensorData | DoorSensorData)[] = sensorsData.map((tag: any) => ({
            macAddr: tag.name || tag.label || tag.macAddr || tag.mac || tag.id,
            label: tag.label || tag.name || `Capteur ${tag.name || tag.label || tag.macAddr || tag.mac || tag.id}`,
            actif: tag.active !== false && tag.status !== 'inactive',
            alertes: tag.alerts || tag.hasAlerts || false,
            battery: tag.battery || tag.batteryLevel || 100,
            // Add temperature/humidity properties if it's a temp sensor
            ...(tag.type === 'temperature' || tag.sensorType === 'temp' ? {
              temperature: tag.temperature || 0,
              humidity: tag.humidity || 0,
              temperatureMin: tag.tempMin || -10,
              temperatureMax: tag.tempMax || 30,
              humidityMin: tag.humMin || 30,
              humidityMax: tag.humMax || 70
            } : {}),
            // Add door sensor properties if it's a door sensor
            ...(tag.type === 'door' || tag.sensorType === 'door' ? {
              isOpen: tag.isOpen || tag.doorOpen || false,
              lastOpened: tag.lastOpened || null
            } : {})
          }));

          setSensors(transformedSensors);
          console.log('✅ Capteurs chargés pour RapportList:', transformedSensors.length);
        } else {
          console.log('❌ Aucun capteur reçu');
          setSensors([]);
        }
      } catch (error) {
        console.error('❌ Erreur lors du chargement des capteurs:', error);
        setSensors([]);
      } finally {
        setLoading(false);
      }
    };

    loadSensors();
  }, []);

  if (loading) {
    return (
      <div style={{ minWidth: 300, padding: 16, borderRight: '1px solid #eee', textAlign: 'center' }}>
        <CircularProgress size={24} />
        <div style={{ marginTop: 16 }}>Chargement des capteurs...</div>
      </div>
    );
  }

  return (
    <div style={{ minWidth: 300, padding: 16, borderRight: '1px solid #eee' }}>
      <h3>Sélection du capteur</h3>
      
      <FormControl fullWidth style={{ marginBottom: 16 }}>
        <InputLabel id="select-capteur-label">Choisir un capteur</InputLabel>
        <Select
          labelId="select-capteur-label"
          value={selectedMac}
          label="Choisir un capteur"
          onChange={e => onSensorSelect(e.target.value)}
        >
          {sensors.map((sensor) => (
            <MenuItem key={sensor.macAddr} value={sensor.macAddr}>
              {sensor.label} ({'temperature' in sensor ? 'Temp/Hum' : 'Porte'})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Bilan général */}
      <div style={{ marginTop: 24 }}>
        <h4>Bilan général</h4>
        <div style={{ fontSize: '0.9em', lineHeight: 1.6 }}>
          <div><b>Total capteurs :</b> {sensors.length}</div>
          <div><b>Actifs :</b> <span style={{ color: 'green' }}>{sensors.filter(s => s.actif).length}</span></div>
          <div><b>Inactifs :</b> <span style={{ color: 'red' }}>{sensors.length - sensors.filter(s => s.actif).length}</span></div>
          <div><b>En alerte :</b> <span style={{ color: sensors.filter(s => s.alertes).length ? 'orange' : 'inherit' }}>{sensors.filter(s => s.alertes).length}</span></div>
          <div><b>Batterie faible :</b> <span style={{ color: sensors.filter(s => s.battery < 30).length ? 'red' : 'inherit' }}>{sensors.filter(s => s.battery < 30).length}</span></div>
        </div>
      </div>
      
      {/* Settings Button */}
      <Button 
        variant="outlined" 
        onClick={onToggleSettings}
        style={{ marginTop: 16, width: '100%' }}
      >
        Paramètres
      </Button>
    </div>
  );
};

export default RapportList;
